import React, { useCallback, useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import { convertAmount, dotFormatter, roundNumber } from '../../../../../helpers';
import { useStore, useTranslation } from '../../../../../hooks';
import { NextDropDate } from './next-drop-date';
import { T } from '../../../../../constants';

interface FreeDropAnnouncementModalProps {
  nextDropDate: Date | null;
}

export const FreeDropAnnouncementModal: React.FC<FreeDropAnnouncementModalProps> = observer(({ nextDropDate }) => {

  const t = useTranslation();
  const { freeDropStore, gameStore } = useStore();

  const { freeDropInfo, themeConfig } = freeDropStore;
  const { currencySymbol, currencyCode, rate, precision, isSlotLine } = gameStore;

  const closePopup = useCallback(() => {
    freeDropStore.setShowAnouncementPopup(false);
  }, []);

  const maxWin = useMemo(() => {

    let freeDropHasUserCurrencyConfig = true;

    const sum = freeDropInfo?.drops.reduce<number>((dropsSum, drop) => {
      dropsSum = dropsSum + drop.tiers.reduce<number>((tierSum, tier) => {

        let freebet = tier.freeBets.find(({ currency }) => currency === currencyCode);

        if (!freebet) {
          freeDropHasUserCurrencyConfig = false;
          freebet = tier.freeBets.find(({ currency }) => currency === freeDropInfo.currency);
        }

        // if free drop has user currency config then use amount else use coin amount
        tierSum = tierSum + (((freeDropHasUserCurrencyConfig ? freebet?.amount : freebet?.coinAmount) || 0) * (freebet?.count || 0))
        return tierSum;
      }, 0);
      return dropsSum;
    }, 0);
    
    // if free drop has user currency config then round sum else convert and round sum
    const result = freeDropHasUserCurrencyConfig ? roundNumber(sum || 0, precision) : convertAmount(sum || 0, rate, precision)
    return `${currencySymbol}${dotFormatter(result)}`
  }, [currencySymbol, freeDropInfo, precision, rate, currencyCode]);

  if (!freeDropInfo) return null;

  // slot line small view moves next to the free drop widget
  const viewClassName = freeDropInfo.smallView ? `small-view ${isSlotLine ? 'slot-line' : ''}` : 'big-view';

  return (
    <div className={`free-drop-popup-wrapper-live ${viewClassName}`}>
      <div className="free-drop-popup-wrapper-live-holder">
        <span className="gift-image close-gift-image-holder"></span>
        <div
          className="gift-image money-gift-image-holder money"
          style={{ backgroundImage: `url(${themeConfig.smallPopupImage})` }}
        >
          <span className="gift-image-text"></span>
        </div>
        <button type="button" className="free-drop-popup-live-close" onClick={closePopup}>
          <i className="icon-close free-drop-popup-close-icon" />
        </button>
        <div className="free-drop-popup-wrapper-live-content">
          <h3 className="free-drop-is-live-text">{t(T.FREE_DROP)}</h3>
          <p className="free-drop-live-content-text">
            {t(T.EVERY_BET_ADDS_ENERGY)}
          </p>
          <p className="free-drop-live-content-text">
            {t(T.HIGHER_YOUR_LEVEL_BIGGER_PRIZE)}
          </p>
          <p className="free-drop-live-next-drop">{t(T.NEXT_DROP_IN)}</p>
          {
            nextDropDate ? (
              <NextDropDate date={nextDropDate} />
            ) : null
          }
          <div className="win-up-to-block">
            <p className="win-up-to-text">{t(T.PRIZE_POOL)}: </p>
            <p className="win-up-to-price">{ maxWin }</p>
          </div>
          <div className={`gif-block ${themeConfig.announcementGifClassName}`}>
            <img src={themeConfig.announcementGif} alt="" />
          </div>
          <p className="win-your-reward">{t(T.FREE_DROP_TAP_TO_OPEN)}</p>
          <p className="win-your-reward">{t(T.FREE_DROP_WIN_YOUR_REWARD)}</p>
          <button
            type="button"
            onClick={closePopup}
            className="start-playing-btn"
          >
            <span className="start-playing-btn-text">{t(T.OK)}</span>
          </button>
        </div>
      </div>
    </div>
  );
});
